import { captureSentry } from "sentry";

const NotFoundPage = (props) => {
  captureSentry(props);
  return "Not Found";
};

export default NotFoundPage;
